const AnalyticEvent = async (layer , event={}) => {
    const p = new Promise((resolve,reject) => {
        const o = {
            "name": event.eventInfo.eventName,
            "module": "registration",
            "timestamp": new Date(),
            attributes : event.attributes,
            "action" : event.eventInfo.eventAction || ""
        };
        if(layer){
            layer.setEvent(o);
            resolve();
        }
        else{
            console.log(JSON.stringify(o));
            reject();
        }
    });

    return await p;
};

const DirectCall = async (drc, step = "" ) => {

    const p = new Promise((resolve, reject) => {

        if(drc && step.length > 0 ){
            drc.track(step);
            resolve();
        }
        else{
            console.log(step);
            reject("No api available for Direct Call ");
        }
    });

    return p
};

export default AnalyticEvent
export {
    AnalyticEvent , DirectCall
}